import { IAppEnvironment } from '@core-lib/models';

const [version, buildNumber] = require('../../../../../package.json').version.split("+");

export const environmentCore: IAppEnvironment = {
	local: false,
	dev: false,
	staging: false,
	qual: false,
	integration: false,
	production: false,
	sharedAssetsPath: './shared-assets',
	fakeAuth: true,
	appVersion: version,
	buildNumber: buildNumber,
	newVersionCheckIntervalMs: 1 * 60 * 60 * 1000, // every 1 hour
	acceptedFileTypes: [
		{ "extension": ".csv", "mime": "text/csv"},
		{ "extension": ".pdf", "mime": "application/pdf" },
		{ "extension": ".png", "mime": "image/png" },
		{ "extension": ".jpg", "mime": "image/jpeg" },
		{ "extension": ".jpeg", "mime": "image/jpeg" },
		{ "extension": ".gif", "mime":  "image/gif" },
		{ "extension": ".docx", "mime": "application/vnd.openxmlformats-officedocument.wordprocessingml.document" },
		{ "extension": ".xlsx", "mime": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" },
		{ "extension": ".pptx", "mime": "application/vnd.openxmlformats-officedocument.presentationml.presentation" }
	]
};
